import { createSlice } from '@reduxjs/toolkit'

export const examSlice = createSlice({
    name: 'exam',
    initialState: {
        data: {
            textHighlightOrNote: [],
        }
    },
    reducers: {
        addAction: (state, action) => {

            return {
                ...state,
                data: {
                    ...state.data,
                    textHighlightOrNote: [...state.data.textHighlightOrNote, action.payload]
                }
            }
        },
        removeAction: (state, action) => {
            localStorage.clear()
            return {
                ...state,
                data: {
                    ...state.data,
                    textHighlightOrNote: state.data.textHighlightOrNote.filter(
                        item => item.id !== action.payload
                    )
                }
            }
        },
    },
})
export const { addAction, removeAction } = examSlice.actions
export default examSlice.reducer